import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, ScaleIcon } from 'lucide-react';
import { ListingCard } from '../components/ListingCard';
const tabs = ['Cars', 'Properties', 'Jobs', 'Services', 'Products'];
const mockSaved = [{
  id: '1',
  title: 'Toyota Land Cruiser Prado GXR 2018',
  price: 'AED 82,000',
  location: 'Al Quoz, Dubai',
  images: ['https://images.unsplash.com/photo-1590362891991-f776e747a588?auto=format&fit=crop&q=80&w=800'],
  specs: [{
    label: 'Year',
    value: '2018'
  }, {
    label: 'Mileage',
    value: '112,000 km'
  }],
  matchScore: 98,
  sellerType: 'Verified Business' as const,
  isSaved: true
}, {
  id: '2',
  title: 'Toyota Prado TXL 2019 Clean',
  price: 'AED 89,000',
  location: 'Abu Shagara, Sharjah',
  images: ['https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?auto=format&fit=crop&q=80&w=800'],
  specs: [{
    label: 'Year',
    value: '2019'
  }, {
    label: 'Mileage',
    value: '85,000 km'
  }],
  matchScore: 94,
  sellerType: 'Individual' as const,
  isSaved: true
}];
export function Saved() {
  const [activeTab, setActiveTab] = useState('Cars');
  const [selectedForCompare, setSelectedForCompare] = useState<string[]>([]);
  const toggleCompare = (id: string) => {
    if (selectedForCompare.includes(id)) {
      setSelectedForCompare(selectedForCompare.filter(itemId => itemId !== id));
    } else {
      if (selectedForCompare.length < 3) {
        setSelectedForCompare([...selectedForCompare, id]);
      }
    }
  };
  return <div className="flex-1 p-4 lg:p-8 max-w-7xl mx-auto w-full" data-id="element-5989" data-mp="33rt95ble3pnv">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8" data-id="element-5990" data-mp="52ui09zlptwh">
        <div data-id="element-5991" data-mp="cdzwcku5k3s">
          <h1 className="font-display font-bold text-3xl text-dark-navy mb-2" data-id="element-5992" data-mp="bvw8uvug3lu">
            Saved Items
          </h1>
          <p className="text-slate-500" data-id="element-5993" data-mp="1ulatlkz6xahb">
            Your favorite listings across all categories.
          </p>
        </div>

        {selectedForCompare.length > 0 && <motion.button initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-primary-indigo to-ai-purple text-white rounded-xl font-medium shadow-md hover:shadow-lg transition-all" data-id="element-5994" data-mp="1kuolscxpto96">
            <ScaleIcon className="w-5 h-5" data-id="element-5995" data-mp="11vu2cqnb3zmo" />
            Ask Talab to Compare ({selectedForCompare.length})
          </motion.button>}
      </div>

      {/* Tabs */}
      <div className="flex overflow-x-auto pb-4 mb-6 no-scrollbar gap-2 border-b border-slate-200" data-id="element-5996" data-mp="2w9bvquae7qpm">
        {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-3 whitespace-nowrap font-medium transition-all border-b-2 ${activeTab === tab ? 'border-primary-indigo text-primary-indigo' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}`} data-id="element-5997" data-mp="318oh1alm8pq3">
            Saved {tab}
          </button>)}
      </div>

      {/* AI Prompt Banner */}
      <div className="bg-gradient-to-r from-primary-indigo/5 to-ai-purple/5 rounded-2xl p-4 mb-8 border border-primary-indigo/10 flex items-center justify-between" data-id="element-5998" data-mp="uil2i46g0nmr">
        <div className="flex items-center gap-3" data-id="element-5999" data-mp="13d98xxnr8bd5">
          <div className="p-2 bg-white rounded-lg shadow-sm" data-id="element-6000" data-mp="13ekg87ges190">
            <SparklesIcon className="w-5 h-5 text-ai-purple" data-id="element-6001" data-mp="1i8fhose8ioa6" />
          </div>
          <p className="text-slate-700 font-medium" data-id="element-6002" data-mp="1dady86cwcmy6">
            Select up to 3 items to let AI compare them for you.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-6003" data-mp="3k37rxsk2qqug">
        {mockSaved.map((item, idx) => {
        const isSelected = selectedForCompare.includes(item.id);
        return <motion.div key={item.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} className="relative" data-id="element-6004" data-mp="2b3wrfvdz9aqo" data-mpi={idx}>
              <div className={`absolute -left-2 -top-2 z-10 transition-all ${isSelected ? 'opacity-100' : 'opacity-0'}`} data-id="element-6005" data-mp="1ngf4qe9kl2uk">
                <div className="w-6 h-6 bg-primary-indigo text-white rounded-full flex items-center justify-center font-bold text-xs shadow-md border-2 border-white" data-id="element-6006" data-mp="1wf0lc3vhe7sp">
                  {selectedForCompare.indexOf(item.id) + 1}
                </div>
              </div>

              <div className={`rounded-2xl transition-all ${isSelected ? 'ring-2 ring-primary-indigo ring-offset-2' : ''}`} onClick={() => toggleCompare(item.id)} data-id="element-6007" data-mp="18poevbrjgdu3">
                <ListingCard {...item} data-id="element-6008" data-mp="w7c202ipagz6" />
              </div>

              <div className="mt-3 text-center" data-id="element-6009" data-mp="w7vlvorwvffu">
                <button onClick={() => toggleCompare(item.id)} className={`text-sm font-medium transition-colors ${isSelected ? 'text-primary-indigo' : 'text-slate-500 hover:text-slate-800'}`} data-id="element-6010" data-mp="s4pg0i8pnq9w">
                  {isSelected ? 'Selected for comparison' : 'Select to compare'}
                </button>
              </div>
            </motion.div>;
      })}
      </div>
    </div>;
}